<h2 class="text-left">Setup Time-based One-time Password MFA</h2>
<div class="setup-mfa">
  <mat-card>
    <mat-card-title>
      Step 1
    </mat-card-title>
    Open your favorite authenticator app on your smartphone.
    If you don't have one, we suggest Duo for <a href="https://apps.apple.com/us/app/duo-mobile/id422663827?mt=8">iOS</a>
    or <a href="https://play.google.com/store/apps/details?id=com.duosecurity.duomobile&hl=en">Android</a>.
  </mat-card>
  <mat-card class="center">
    <mat-card-title>
      Step 2
    </mat-card-title>
    Scan QR code below using the app.
    <img alt="QR code" [src]="otpQr ? otpQr : 'data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=='">
    <div class="button">
      <button (click)="init()" mat-raised-button>Reload</button>
    </div>
  </mat-card>
  <mat-card>
    <mat-card-title>
      Step 2
    </mat-card-title>
    Enter the temporary code provided by the app.
    <mat-form-field>
      <input [(ngModel)]="code" matInput type="password">
    </mat-form-field>
    <div class="button">
      <button (click)="submit()" mat-raised-button>Submit</button>
    </div>
  </mat-card>
</div>
